import { Composition, staticFile } from 'remotion';
import SimulatorVideo from './simulator-video';
import { calcDuration } from '../utils/duration-calculator';
import './remotion.css';

// Load all scenario JSON files from public/scenarios/
const scenarioFiles = {
  // Bai 1: Tong quan .NET va C# co ban
  'hello-world': 'scenarios/hello-world-with-audio.json',
  'csharp-variables': 'scenarios/csharp-variables-with-audio.json',
  'csharp-constants': 'scenarios/csharp-constants-with-audio.json',
  'csharp-value-types': 'scenarios/csharp-value-types-with-audio.json',
  'csharp-string-ops': 'scenarios/csharp-string-ops-with-audio.json',
  'csharp-operators': 'scenarios/csharp-operators-with-audio.json',
  'csharp-if-else': 'scenarios/csharp-if-else-with-audio.json',
  'csharp-arrays-loops': 'scenarios/csharp-arrays-loops-with-audio.json',
  'csharp-method-basics': 'scenarios/csharp-method-basics-with-audio.json',
  'csharp-type-conversion': 'scenarios/csharp-type-conversion-with-audio.json',
  'csharp-console-io': 'scenarios/csharp-console-io-with-audio.json',
  'csharp-namespace-using': 'scenarios/csharp-namespace-using-with-audio.json',
  'csharp-exception-handling': 'scenarios/csharp-exception-handling-with-audio.json',
  'csharp-enum-struct': 'scenarios/csharp-enum-struct-with-audio.json',
  'csharp-nullable-types': 'scenarios/csharp-nullable-types-with-audio.json',
  'csharp-lab01-student-info': 'scenarios/csharp-lab01-student-info-with-audio.json',
};

function ScenarioComposition({ id, file }) {
  return (
    <Composition
      id={id}
      component={SimulatorVideo}
      fps={60}
      width={1920}
      height={1080}
      durationInFrames={1} // placeholder, calculated below
      calculateMetadata={async () => {
        const res = await fetch(staticFile(file));
        const scenario = await res.json();
        const fps = scenario.fps || 60;
        const totalFrames = scenario.scenes.reduce(
          (sum, s) => sum + (s.durationInFrames || calcDuration(s, fps)),
          0
        );
        return {
          fps,
          width: scenario.width || 1920,
          height: scenario.height || 1080,
          durationInFrames: totalFrames,
          props: { scenario },
        };
      }}
    />
  );
}

export default function RemotionRoot() {
  return (
    <>
      {Object.entries(scenarioFiles).map(([id, file]) => (
        <ScenarioComposition key={id} id={id} file={file} />
      ))}
    </>
  );
}
